import { useTranslation } from 'react-i18next';

import { ReferralStep } from './ReferralStep';

/**
 * "Cómo funciona" section: the three referral steps.
 * Three columns on desktop, stacked on mobile.
 *
 * @returns {React.ReactElement} The how-it-works section
 */
export const ReferralHowItWorks = () => {
  const { t } = useTranslation('referral');

  return (
    <section className="flex flex-col gap-4">
      <h2 className="text-xs uppercase tracking-widest text-muted-foreground">{t('howItWorks.title')}</h2>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <ReferralStep number="01" tag={t('howItWorks.steps.one.tag')} text={t('howItWorks.steps.one.text')} />
        <ReferralStep number="02" tag={t('howItWorks.steps.two.tag')} text={t('howItWorks.steps.two.text')} />
        <ReferralStep
          number="03"
          tag={t('howItWorks.steps.three.tag')}
          tagAmount={t('howItWorks.steps.three.tagAmount')}
          text={t('howItWorks.steps.three.text')}
        />
      </div>
    </section>
  );
};
